// tanstack
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/',
)({
  component: () => <Navigate to="analysis/overview" replace />,
});
